import { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { gerAdminBlockAccountsRoute, gerAdminSpanAccountsRoute } from '../api/constant';
import { adminEmployersList, blockAccountList, errorMessage, spamAccountList } from '../constants';
import axiosInstance from '@server/axiosInstance';

type useGetBlockAccountsProps = {
    searchValue: string;
    sortedDirection: string;
    page: number;
    columnNo: number;
    page_length: number;
    setAlertText?: Dispatch<SetStateAction<string>>;

};

const constructQueryString = (
    page: number,
    page_length: number,
    searchValue: string,
    columnNo: number,
    sortedDirection: string,
) => {
    const encodedSearchValue = encodeURIComponent(searchValue);
    let queryString = `?page=${page}&page_length=${page_length}&query=${encodedSearchValue}&sort_columns=${columnNo}&sort_direction=${sortedDirection}`;
    return queryString;
};


export const useGetBlockAccounts = ({
    page,
    page_length,
    columnNo,
    sortedDirection,
    searchValue,
    setAlertText = () => { },
}: useGetBlockAccountsProps) => {

    const queryString = constructQueryString(page, page_length, searchValue, columnNo, sortedDirection);

    const { data: employers, isFetching: isLoadingEmployers } =

        useQuery({
            queryKey: [blockAccountList, columnNo, sortedDirection, page, searchValue, page_length],
            queryFn: () =>

                axiosInstance
                    .get(gerAdminBlockAccountsRoute + queryString)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setAlertText(data.message);
                } else {
                    setAlertText('');
                }
            },
            onError: () => {
                setAlertText(errorMessage);
            },
            refetchOnWindowFocus: false,
        });

    return {
        employers,
        isLoadingEmployers,
    };
};
